// extracted by mini-css-extract-plugin
export default {"root":"ArchiveCardList_root__92-yO","list":"ArchiveCardList_list__oIQKK"};